var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 51C12.9 52.3 14 53.4 15.3 53.4H44.7C46 53.4 47.1 52.3 47.1 51V47.6H12.9V51Z",
    fill: "#008C78",
    stroke: "#008C78",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1 28.7V48.4C47.1 49.7 46 50.8 44.7 50.8H15.3C14 50.8 12.9 49.7 12.9 48.4V28.7",
    fill: "#00A997"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1 28.7V48.4C47.1 49.7 46 50.8 44.7 50.8H15.3C14 50.8 12.9 49.7 12.9 48.4V28.7",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 28.7V8.20001C12.9 7.30001 13.6 6.60001 14.5 6.60001H45.5C46.4 6.60001 47.1 7.30001 47.1 8.20001V28.7H12.9Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18.2C23.5 16.5 24.7 15.3 26.5 15.3C28.3 15.3 29.5 16.5 29.5 18.2C29.5 19.9 28.3 21.1 26.5 21.1C24.7 21.1 23.5 19.9 23.5 18.2ZM28.2 18.2C28.2 17.1 27.5 16.3 26.5 16.3C25.5 16.3 24.8 17.1 24.8 18.2C24.8 19.3 25.5 20.1 26.5 20.1C27.5 20.1 28.2 19.3 28.2 18.2Z",
    fill: "#E0BF53",
    stroke: "#E0BF53",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3 21L32.6 17.3V21H31.4V15.3H32.6L35.2 18.9V15.3H36.4V21H35.2H35.3Z",
    fill: "#E0BF53",
    stroke: "#E0BF53",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 40.3C21.6 38.6 22.8 37.4 24.6 37.4C26.4 37.4 27.6 38.6 27.6 40.3C27.6 42 26.4 43.2 24.6 43.2C22.8 43.2 21.6 42 21.6 40.3ZM26.3 40.3C26.3 39.2 25.6 38.4 24.6 38.4C23.6 38.4 22.9 39.2 22.9 40.3C22.9 41.4 23.6 42.2 24.6 42.2C25.6 42.2 26.3 41.4 26.3 40.3Z",
    fill: "#008C78",
    stroke: "#008C78",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43.1V37.4H33V38.5H30.2V39.7H32.9V40.8H30.2V43.1H29Z",
    fill: "#008C78",
    stroke: "#008C78",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 43.1V37.4H38.4V38.5H35.6V39.7H38.3V40.8H35.6V43.1H34.4Z",
    fill: "#008C78",
    stroke: "#008C78",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.034949b61ab21e24e859150c9c755327.svg";
export { ForwardRef as ReactComponent };